module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-05.f51e84a5.png";